import React, { useEffect, useState } from "react";
import {
  Input,
  Space,
  Table,
  Breadcrumb,
  Popconfirm,
  Tooltip,
  Form,
  Button,
} from "antd";
import { ReactComponent as ArchiveRestore } from "../../../image/ArchiveRestore.svg";
import { Link, useNavigate } from "react-router-dom";
import ButtonField from "../../../common/htmlComponents/ButtonField";
import { useTranslation } from "react-i18next";
import { getRequest, postRequest } from "../../../axios";
import { debounce } from "lodash";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../../utils/Notifications";
import SearchIcon from "../../../image/SearchIcon.svg";
import "antd/dist/antd.min.css";
import "../../../styles/Main.scss";
import { UndoOutlined } from "@ant-design/icons";

const { Search } = Input;

const ArchiveAreaList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [reload, setReload] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [archiveAreaList, setArchiveAreaList] = useState([]);

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getArchiveAreaList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          "customer-zone/archived-customer-zone-list/",
          state
        );
        if (apiResponse.status) {
          setArchiveAreaList(apiResponse.data.results);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archive_list"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getArchiveAreaList();
  }, [state, reload, t]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";
    if (sortField === "customer_zone" && sortOrder === "ascend") {
      sortingEnumKey = "customer_zone";
    }
    if (sortField === "customer_zone" && sortOrder === "descend") {
      sortingEnumKey = "-customer_zone";
    }
    if (sortField === "country" && sortOrder === "ascend") {
      sortingEnumKey = "country__name";
    }
    if (sortField === "country" && sortOrder === "descend") {
      sortingEnumKey = "-country__name";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    form.setFieldsValue({ search: "" });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {},
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest(
        "customer-zone/restore-customer-zone/",
        {
          deleted: ids,
        }
      );
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("area_restore_successfully"));
        setReload(!reload);
        setSelectedRow([]);
        navigate("/customer-zone");
      } else {
        ErrorNotificationMsg(t("error_in_restore_area"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Zone",
      dataIndex: "customer_zone",
      key: "customer_zone",
      sorter: true,
    },

    {
      title: "State",
      dataIndex: "state_name",
      key: "state",
      sorter: true,
    },
    {
      title: "Country",
      dataIndex: "country_name",
      key: "country",
      sorter: true,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: "100px",
      render: (text, record) => (
        <Space>
          {/* <Tooltip
            color={colors}
            placement="right"
            title={<span style={{ color: "#fff" }}>Restore</span>}
          > */}
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore className="ArchiverestorImg" />
          </Popconfirm>
          {/* </Tooltip> */}
        </Space>
      ),
    },
  ];
  const colors = ["#737373"];
  return (
    <div>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("archived_area_list")}</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/customer-zone">{t("area")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("archived_area_list")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp" style={{ height: "40px" }}>
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}
            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_restore_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleRestore()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_restore")}
                />
              </Popconfirm>
            )}
          </Space>
        </div>
      </div>

      <section className="grid-sec">
        <div className="PR-body">
          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archiveAreaList}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page",
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("pl_back_to_list")}
              onClick={() => navigate(`/customer-zone`)}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default ArchiveAreaList;
